import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

import Layout from '../views/layout/Layout'

export default new Router({
  routes: [
    {
      path: '/',
      name: 'HelloWorld',
      component: Layout,
      redirect: 'dashboard',
      children: [{
        path: 'dashboard',
        component: () => import('@/views/echarts/dashboard'),
        name: '首页',
        meta: { title: '首页', icon: 'dashboard', noCache: true }
      }]
    },
    {
      path: '/myBlog',
      name: 'myBlog',
      component: Layout,
      children: [
        {
          path: 'https://dongkelun.com/',
          meta: { title: '我的博客', icon: 'link' }
        }
      ]
    },
    {
      path: 'vue-echarts-map',
      name: 'vue-echarts-map',
      component: Layout,
      children: [
        {
          path: 'http://gh.dongkelun.com/vue-echarts-map',
          meta: { title: 'Echarts地图钻取', icon: 'link' }
        }
      ]
    },
    {
      path: 'myGit',
      name: 'myGit',
      component: Layout,
      children: [
        {
          path: 'https://github.com/dongkelun',
          meta: { title: 'Github', icon: 'link' }
        }
      ]
    }

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js